<nav #header class="fixed-top" style="background-color: transparent;filter: drop-shadow(1px 1px 1px #6666664d);">
    <div class="containerMenu navbar-collapse collapse">
        <div class="icons" style="display: flex;align-items: left;">
            <a href="https://www.instagram.com/galapagos_destiny?igsh=MXJvc2NsNGFkNmN2dA%3D%3D&utm_source=qr"
                target="_blank"><i class="fa fa-instagram"></i></a>
            <a href="https://www.tripadvisor.com/Attraction_Review-g297533-d19793526-Reviews-Galapagos_Destiny-Puerto_Ayora_Santa_Cruz_Galapagos_Islands.html"
                target="_blank"><i class="fa fa-tripadvisor"></i></a>

        </div>
        <div>
            <a href="https://galapagosdestinytours.com/" target="_blank">
                <img class="logo" src="../assets/images/logos-header/gdt.svg" />
            </a>
        </div>
        <div style="display: flex;align-items: center;">
            <a class="menuButton" (click)="renderMenu()" href="javascript:void()"><i class="fa fa-bars"></i></a>
        </div>

    </div>
    <div #header1 class="containerHeader" [ngClass]="showMenu ? 'showMenu':''">
        <ul class="navbar-nav">
            <li class="nav-item menuItem"><a href="https://galapagosdestinytours.com/" target="_blank">Home</a>
            </li>
            <li class="nav-item menuItem"><a href="https://galapagosdestinytours.com/full-day-tours"
                    target="_blank">Activities</a>
            </li>
            <li class="nav-item menuItem"><a href="https://galapagosdestinytours.com/partners" target="_blank">Business
                    Group</a></li>
            <li class="nav-item menuItem"><a href="https://galapagosdestinytours.com/contact-1"
                    target="_blank">Contact</a></li>
            <li class="nav-item menuItem"><a href="https://galapagosdestinytours.com/policies"
                    target="_blank">Policies</a></li>
            <li class="nav-item menuItem"><a href="https://galapagosdestinytours.com/about-us" target="_blank">About
                    us</a>
            </li>
        </ul>
        <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
            <app-heart-header></app-heart-header>
        </div>
    </div>
</nav>